import { useEffect, useState } from "react";
import { api, fmtCurrency } from "../../lib/api";
import MobileHeader from "../../components/MobileHeader";
import { Plus, Briefcase } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function BusinessSuppliers() {
    const [items, setItems] = useState([]);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ name: "", category: "" });
    const refresh = () => api.get("/business/suppliers").then((r) => setItems(r.data));
    useEffect(() => { refresh(); }, []);

    const submit = async () => {
        if (!form.name) return toast.error("Name required");
        await api.post("/business/suppliers", form);
        setOpen(false); setForm({ name: "", category: "" }); refresh(); toast.success("Supplier added");
    };

    return (
        <div data-testid="suppliers-page">
            <MobileHeader title="Suppliers" backTo="/business/more" variant="blue" />
            <div className="px-5 -mt-6 pb-4 space-y-3">
                <div className="bg-white rounded-2xl border border-slate-200/60 overflow-hidden product-shadow">
                    {items.length === 0 && <div className="p-8 text-center text-sm text-slate-500">No suppliers</div>}
                    {items.map((s, i) => (
                        <div key={s.id} className={`flex items-center gap-3 px-4 py-3.5 ${i !== items.length - 1 ? "border-b border-slate-100" : ""}`} data-testid={`supplier-${s.id}`}>
                            <div className="size-10 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center"><Briefcase size={18} /></div>
                            <div className="flex-1"><div className="font-semibold text-sm">{s.name}</div><div className="text-xs text-slate-500">{s.category || "—"}</div></div>
                        </div>
                    ))}
                </div>
                <Button onClick={() => setOpen(true)} className="w-full h-12 rounded-xl bg-[#0066FF]" data-testid="add-supplier-btn"><Plus size={18} /> Add Supplier</Button>
            </div>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="rounded-2xl">
                    <DialogHeader><DialogTitle>New Supplier</DialogTitle></DialogHeader>
                    <div className="space-y-3">
                        <div><Label>Name</Label><Input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} className="mt-1.5 h-11 rounded-xl" data-testid="sup-name" /></div>
                        <div><Label>Category</Label><Input value={form.category} onChange={(e) => setForm((f) => ({ ...f, category: e.target.value }))} className="mt-1.5 h-11 rounded-xl" data-testid="sup-cat" /></div>
                        <Button onClick={submit} className="w-full h-11 rounded-xl bg-[#0A1930]" data-testid="sup-submit">Add</Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
